import { useContests } from '@bpm-web-app/swr-hooks';
import { createAppRoutes, SeeMoreItem } from '@bpm-web-app/utils';
import { useMemo } from 'react';
import SeeMoreLayout from '../see-more-layout/see-more-layout';

export interface ContestsListProps {
    itemBasePath?: string;
}

export function ContestsList({ itemBasePath = createAppRoutes.contest }: ContestsListProps) {
    const { contests } = useContests();

    const contestsData = useMemo<SeeMoreItem[] | undefined>(
        () => {
            const currentContests: SeeMoreItem[] | undefined =
            contests?.current
                ?.map((contest) => ({
                    id: contest.id,
                    title: contest.title,
                    image_url: contest.artwork_url,
                    slug: contest.slug,
                    description: null,
                }));
            const pastContests: SeeMoreItem[] | undefined =
                    contests?.past?.map((contest) => ({
                        id: contest.id,
                        title: contest.title,
                        image_url: contest.artwork_url,
                        description: null,
                        slug: contest.slug,
                        label: 'expired',
                    }));

            return currentContests?.concat(pastContests ?? []);
        },
        [contests]
    );
    return <SeeMoreLayout contentType="contest" pageTitle="Contests" count={contestsData?.length || 0} itemBasePath={itemBasePath} data={contestsData ?? []} />;
}

export default ContestsList;
